/* @flow strict */

import * as React from 'react';
import Dropdown from './dropdown';
import '../registrationInfoForm.scss';
import _ from 'lodash';

type PropsType = {
  onChange: () => void,
  withYear: boolean
};
const BirthdayInput = (props: PropsType): React.Element<'div'> => {
  const { onChange, withYear } = props;
  const options = [
    {
      id: 1,
      text: 'January'
    },
    {
      id: 2,
      text: 'February'
    },
    {
      id: 3,
      text: 'March'
    },
    {
      id: 4,
      text: 'April'
    },
    {
      id: 5,
      text: 'May'
    },
    {
      id: 6,
      text: 'June'
    },
    {
      id: 7,
      text: 'July'
    },
    {
      id: 8,
      text: 'August'
    },
    {
      id: 9,
      text: 'September'
    },
    {
      id: 10,
      text: 'October'
    },
    {
      id: 11,
      text: 'November'
    },
    {
      id: 12,
      text: 'December'
    }
  ];

  return (
    <div className='sparxo-checkout-registration-info-form_birthdayContainer'>
      <div className='sparxo-checkout-registration-info-form_birthMonth'>
        <Dropdown
          value={_.toString(1)}
          options={options}
          name='birthMonth'
          placeholder={'Month'}
          maxHeight={240}
          onChange={(e: {}): void => onChange(e)}
        />
      </div>
      <div className='sparxo-checkout-registration-info-form_birthDay'>
        <input className='sparxo-checkout-registration-info-form_input' placeholder='Day' name='birthDay' type='text'
          maxLength={2}
          onChange={(e: {}): void => onChange(e)}
        />
      </div>
      {
        withYear &&
        <div className='sparxo-checkout-registration-info-form_birthYear'>
          <input
            className='sparxo-checkout-registration-info-form_input'
            placeholder='Year'
            name='birthYear'
            type='text'
            maxLength={4}
            onChange={(e: {}): void => onChange(e)}
          />
        </div>
      }

    </div>
  );
};

export default BirthdayInput;
